import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Amenity from './amenity';
import Header from '../../../../../../shared/library/Header/Header';
import './css/Amenities.styl';

export default class Amenities extends Component {
  render() {
    if (!this.props.amenities || this.props.amenities.length === 0) {
      return null;
    }

    const renderAmenities = this.props.amenities.map((amenity, i) => (
      <Amenity key={i} amenity={amenity.name} />
    ));

    return (
      <div>
        <div className="funeral-home-amenities">
          <Header title="Amenities" />
          <ul className="funeral-home-amenities__list">{renderAmenities}</ul>
        </div>
      </div>
    );
  }
}

Amenities.propTypes = {
  amenities: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Amenities/index.js